import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  DefaultPaginationValues,
  queryString,
} from '../../../Util/commonUtility';
import {setEventNameState} from '../../../Store/Actions/chapters';
import {setPageNumber, setPageSize} from '../../../Store/Actions/pageSize';
import AllRefundComponent from '../../../Components/AdminComponents/AllRefund';
import {getRefundByAllEvents} from '../../../Store/Actions/eventRefund';

const AllRefundContainer = () => {
  const dispatch = useDispatch();

  const [allEventRefundData, setAllEventRefundData] = useState();
  const [querySearchValues, setQuerySearchValues] = useState();
  const memorizedPageNumber = useSelector(
    ({pageSizes}) => pageSizes.pageNumbers.allRefunds,
  );
  const memorizedPageSize = useSelector(
    ({pageSizes}) => pageSizes.pageSizes.allRefunds,
  );
  const [pagination, setPagination] = useState({
    page: memorizedPageNumber || DefaultPaginationValues.PAGE,
    pageCount: memorizedPageSize || DefaultPaginationValues.PAGE_SIZE,
    totalPages: DefaultPaginationValues.TOTAL_PAGES,
  });
  const {allEventsRefundDetails} = useSelector(({eventRefund}) => eventRefund);
  const [sortParams, setSortParams] = useState({
    field: 'id',
    order: 'descend',
  });
  const [paginationAndSortChanged, setPaginationAndSortChanged] =
    useState(false);

  const searchValues = useSelector(
    ({dynamicSearch}) => dynamicSearch.searchValues.all_event_refunds,
  );

  useEffect(() => {
    dispatch(setEventNameState(false));
    fetchAllEventRefunds();
  }, []);

  useEffect(() => {
    if (allEventsRefundDetails?.data?.eventRegistrations) {
      setAllEventRefundData(allEventsRefundDetails);
    } else {
      fetchAllEventRefunds();
    }
  }, [allEventsRefundDetails]);

  useEffect(() => {
    if (allEventRefundData?.data) {
      setPagination({
        ...pagination,
        page: allEventRefundData?.data?.currentPage,
        totalPages: allEventRefundData?.data?.totalPage,
        totalCount: allEventRefundData?.data?.totalCount,
      });
    }
  }, [allEventRefundData]);

  useEffect(() => {
    if (paginationAndSortChanged) {
      fetchAllEventRefunds(querySearchValues || searchValues);
      setPaginationAndSortChanged(false);
    }
  }, [paginationAndSortChanged]);

  useEffect(() => {
    if (searchValues) {
      dispatch(setPageNumber('allRefunds', 1));
      setPagination({
        ...pagination,
        page: 1,
      });
      setPaginationAndSortChanged(true);
    }
  }, [searchValues]);

  const handlePaginationChange = (current, pageSize) => {
    dispatch(setPageSize('allRefunds', pageSize));
    dispatch(setPageNumber('allRefunds', current));
    setPagination({
      ...pagination,
      page: current,
      pageCount: pageSize,
    });
    setPaginationAndSortChanged(true);
  };

  const handleTableChange = (pagination, filter, sorter) => {
    setSortParams({
      field: sorter.field,
      order: sorter.order,
    });
    setPaginationAndSortChanged(true);
  };

  const fetchAllEventRefunds = (searchValues) => {
    setQuerySearchValues(searchValues);
    const sortField = sortParams.field || '';
    const sortOrder = sortParams.order || '';
    const searchQueryData = queryString(searchValues);
    dispatch(
      getRefundByAllEvents(pagination, sortField, sortOrder, searchQueryData),
    );
  };

  return (
    <AllRefundComponent
      allEventRefundData={allEventRefundData?.data?.eventRegistrations}
      paging={pagination}
      handlePaginationChange={(page, pageSize) => {
        handlePaginationChange(page, pageSize);
      }}
      handleTableChange={handleTableChange}
      sortParams={sortParams}
      fetchEventRefunds={(searchValues) => {
        fetchAllEventRefunds(searchValues);
      }}
      searchValues={searchValues}
      isAllRefundView
    />
  );
};

export default AllRefundContainer;
